// ─────────────────────────────────────────────────────────
// Mock data para solicitudes de usuarios
// Simula el flujo de solicitudes del sistema
// ─────────────────────────────────────────────────────────

export interface SolicitudData {
	id: number;
	idUsuario: number;
	nombreUsuario: string;
	correoUsuario: string;
	tipoSolicitud: string;
	estado: 'nueva' | 'en_revision' | 'resuelta' | 'rechazada';
	prioridad: 'baja' | 'media' | 'alta' | 'urgente';
	origen: string;
	titulo: string;
	descripcion: string;
	detallesJson: Record<string, unknown>;
	respuestaAdmin?: string;
	comentarioInterno?: string;
	createdAt: string;
	closedAt?: string;
}

export const SOLICITUDES: SolicitudData[] = [
	{
		id: 1001,
		idUsuario: 1,
		nombreUsuario: 'Camila Rojas Morales',
		correoUsuario: 'camila.rojas@uda.cl',
		tipoSolicitud: 'edicion_cv_perfil',
		estado: 'nueva',
		prioridad: 'media',
		origen: 'perfil_propio',
		titulo: 'Agregar formación de Postdoctorado',
		descripcion: 'Solicito agregar mi pasantía postdoctoral realizada en el Centro de Energía Solar de la Universidad de Chile.',
		detallesJson: {
			seccion: 'formacion',
			accion: 'agregar',
			datos: {
				categoria_formacion: 'postdoctorado',
				titulo_obtenido: 'Investigadora Postdoctoral en Energía Solar',
				institucion: 'Centro de Energía Solar, Universidad de Chile',
				pais: 'Chile',
				fecha_inicio: '2019-01-01',
				fecha_termino: '2020-12-31',
				en_curso: false,
				descripcion: 'Investigación postdoctoral sobre integración de energía solar en infraestructura minera.',
			},
		},
		createdAt: '2026-04-01T14:30:00Z',
	},
	{
		id: 1002,
		idUsuario: 1,
		nombreUsuario: 'Camila Rojas Morales',
		correoUsuario: 'camila.rojas@uda.cl',
		tipoSolicitud: 'edicion_cv_perfil',
		estado: 'nueva',
		prioridad: 'baja',
		origen: 'perfil_propio',
		titulo: 'Agregar enlace de ResearchGate',
		descripcion: 'Agregar mi perfil de ResearchGate a los enlaces externos.',
		detallesJson: {
			seccion: 'enlaces',
			accion: 'agregar',
			datos: {
				tipo_enlace: 'researchgate',
				url: 'https://www.researchgate.net/profile/Camila-Rojas-Morales',
				etiqueta: 'ResearchGate',
			},
		},
		createdAt: '2026-04-02T09:15:00Z',
	},
	{
		id: 1003,
		idUsuario: 2,
		nombreUsuario: 'Felipe Salazar Jara',
		correoUsuario: 'felipe.salazar@uda.cl',
		tipoSolicitud: 'edicion_cv_perfil',
		estado: 'en_revision',
		prioridad: 'media',
		origen: 'perfil_propio',
		titulo: 'Actualizar experiencia profesional',
		descripcion: 'Solicito agregar mi experiencia como Data Scientist en Grupo CAP antes de ingresar a la UDA.',
		detallesJson: {
			seccion: 'experiencia',
			accion: 'agregar',
			datos: {
				categoria_experiencia: 'profesional',
				cargo: 'Data Scientist Senior',
				institucion: 'Grupo CAP',
				pais: 'Chile',
				ciudad: 'Santiago',
				fecha_inicio: '2018-01-15',
				fecha_termino: '2020-07-31',
				actual: false,
				descripcion: 'Modelos predictivos para optimización de operaciones mineras.',
			},
		},
		createdAt: '2026-03-28T11:00:00Z',
	},
	{
		id: 1004,
		idUsuario: 3,
		nombreUsuario: 'Sofía Mella Gallardo',
		correoUsuario: 'sofia.mella@uda.cl',
		tipoSolicitud: 'edicion_cv_perfil',
		estado: 'resuelta',
		prioridad: 'media',
		origen: 'perfil_propio',
		titulo: 'Agregar premio de la universidad',
		descripcion: 'Solicito registrar la Distinción Académica otorgada por la UDA en 2025.',
		detallesJson: {
			seccion: 'premios',
			accion: 'agregar',
			datos: {
				nombre_premio: 'Distinción Académica por Trayectoria en Vinculación con el Medio',
				institucion_otorgante: 'Universidad de Atacama',
				anio: 2025,
				pais: 'Chile',
			},
		},
		respuestaAdmin: 'Premio verificado y registrado correctamente en el perfil.',
		createdAt: '2026-03-20T16:45:00Z',
		closedAt: '2026-03-22T10:30:00Z',
	},
	{
		id: 1005,
		idUsuario: 2,
		nombreUsuario: 'Felipe Salazar Jara',
		correoUsuario: 'felipe.salazar@uda.cl',
		tipoSolicitud: 'edicion_cv_perfil',
		estado: 'rechazada',
		prioridad: 'baja',
		origen: 'perfil_propio',
		titulo: 'Agregar certificación profesional',
		descripcion: 'Quisiera agregar mi certificación AWS Solutions Architect.',
		detallesJson: {
			seccion: 'formacion',
			accion: 'agregar',
			datos: {
				categoria_formacion: 'certificacion',
				titulo_obtenido: 'AWS Solutions Architect - Professional',
				institucion: 'Amazon Web Services',
				pais: 'Internacional',
				anio_termino: 2023,
			},
		},
		respuestaAdmin: 'Las certificaciones de proveedor tecnológico no se incluyen en el perfil académico institucional. Puede agregarlo en su perfil cuando la funcionalidad esté habilitada para "Capacitación/Certificación continua".',
		comentarioInterno: 'Pendiente definir política de qué certificaciones profesionales se aceptan. Revisar con VRIP.',
		createdAt: '2026-03-15T08:00:00Z',
		closedAt: '2026-03-18T14:20:00Z',
	},
	{
		id: 1006,
		idUsuario: 1,
		nombreUsuario: 'Camila Rojas Morales',
		correoUsuario: 'camila.rojas@uda.cl',
		tipoSolicitud: 'edicion_cv_perfil',
		estado: 'nueva',
		prioridad: 'media',
		origen: 'perfil_propio',
		titulo: 'Agregar actividad de ponencia',
		descripcion: 'Solicito registrar mi ponencia en el Congreso Internacional de Energía Limpia 2025.',
		detallesJson: {
			seccion: 'actividades',
			accion: 'agregar',
			datos: {
				categoria_actividad: 'ponencia',
				titulo: 'Hidrógeno verde y desarrollo: oportunidades para el norte chileno',
				institucion: 'Congreso Internacional de Energía Limpia',
				pais: 'Chile',
				anio: 2025,
			},
		},
		createdAt: '2026-04-03T11:30:00Z',
	},
];

// Helpers

export function getSolicitudesByUsuario(idUsuario: number) {
	return SOLICITUDES.filter((s) => s.idUsuario === idUsuario).sort(
		(a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
	);
}

export function getSolicitudById(id: number) {
	return SOLICITUDES.find((s) => s.id === id);
}

export function getAllSolicitudes() {
	return [...SOLICITUDES].sort(
		(a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
	);
}

export const ESTADO_SOLICITUD_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
	nueva: { label: 'Nueva', color: 'text-blue-700', bg: 'bg-blue-50 border-blue-200' },
	en_revision: { label: 'En revisión', color: 'text-amber-700', bg: 'bg-amber-50 border-amber-200' },
	resuelta: { label: 'Aprobada', color: 'text-emerald-700', bg: 'bg-emerald-50 border-emerald-200' },
	rechazada: { label: 'Rechazada', color: 'text-red-700', bg: 'bg-red-50 border-red-200' },
	// Not a database state: a rejected request that a newer one replaced (see `claveEstadoVisible`).
	reemplazada: { label: 'Reemplazada', color: 'text-slate-600', bg: 'bg-slate-100 border-slate-300' },
};

export const TIPO_SOLICITUD_LABELS: Record<string, string> = {
	edicion_cv_perfil: 'Edición de CV / Perfil',
	cambio_datos_personales: 'Cambio de datos personales',
	reporte_dato_erroneo: 'Reporte de dato erróneo',
	reporte_dato_faltante: 'Reporte de dato faltante',
	reporte_grafico_sin_datos: 'Reporte de gráfico sin datos',
	reporte_grafico_erroneo: 'Reporte de gráfico erróneo',
	sugerencia_mejora: 'Sugerencia de mejora',
	soporte: 'Soporte técnico',
	cambio_unidad: 'Cambio de unidad',
	cambio_lineas: 'Cambio de líneas',
	otro: 'Otro',
};

export const SECCION_CV_LABELS: Record<string, string> = {
	perfil: 'Datos del Perfil',
	formacion: 'Formación Académica',
	experiencia: 'Experiencia',
	capital_humano: 'Formación de Capital Humano',
	premios: 'Premios y Distinciones',
	cargos: 'Cargos Institucionales',
	actividades: 'Actividades',
	enlaces: 'Enlaces Externos',
};
